<template>
	<div>
		<template v-for="(content, i) in componentItem.content">
			<div :key="i">
				<div v-if="typeof content !== 'object'">
					<div v-if="i === 'content'" class="form-group">
						<label>{{ i }}</label>	
						<textarea rows="5" class="form-control" :id="`${i}ad${index}`" v-model="componentItem.content[i]"></textarea>
					</div>
					<div v-else class="form-group">
						<label>{{ i }}</label>
						<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]" >
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	export default {
		
		name: 'Ad',
		
		props: ['componentItem', 'index'],

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>